/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';
import { GetProject } from './project.get';

const Params = z.strictObject({ organizationId: ZodTypes.Id });

export const GetProjects = {
  id: 'projects.get',
  tag: 'Project',
  summary: 'Get projects',
  description: 'Retrieve all projects within an organization',
  method: 'get',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) => `/organization/${params.organizationId}/project`,
  request: { params: Params },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': { schema: z.array(GetProject.response['200'].content['application/json'].schema) },
      },
    },
  },
} as const satisfies Endpoint;
